module.exports = __webpack_public_path__ + "img/booking_completed.dfd037a1.svg";